import { Outlet } from "@tanstack/react-router"
import { ButtonLink } from "design-system/atoms/Button"
import { BadgePingText } from "design-system/molecules/BadgePingText"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Section } from "design-system/molecules/Section"
import { Pencil } from "lucide-react"
import { useBigBlueIntegrationQuery } from "modules/settings/hooks/bigblue/useBigBlueIntegrationQuery"
import { useTranslation } from "react-i18next"
import { FindOrder } from "./components/findOrder"

export const BigBlueConfiguration = () => {
  const { t } = useTranslation()
  const { data } = useBigBlueIntegrationQuery()
  const hasConfiguration = Boolean(data?.token)
  const areWebhooksWorking = Boolean(
    data?.token && data?.prefix && data?.webhooksSecretKey && data?.webhooksVerifiedAt,
  )
  const disabledReason = t("settings.integrations.disabledRequiresConfiguration")

  return (
    <>
      <div className="flex flex-col gap-8">
        <Card>
          <CardHeader className="flex flex-row gap-4 p-4">
            <div className="grow flex flex-col gap-1">
              <CardTitle>{t("settings.integrations.bigblue.integrationCard.title")}</CardTitle>
              <CardDescription>
                {hasConfiguration
                  ? t("settings.integrations.bigblue.integrationCard.descriptionDone")
                  : t("settings.integrations.bigblue.integrationCard.descriptionPending")}
              </CardDescription>
            </div>
            <div className="flex items-center">
              {hasConfiguration ? (
                <div className="flex flex-wrap items-center justify-end gap-2">
                  <BadgePingText
                    color="success"
                    text={t("settings.integrations.bigblue.integrationCard.connected")}
                  />
                  <BadgePingText
                    color={areWebhooksWorking ? "success" : "warning"}
                    text={
                      areWebhooksWorking
                        ? t("settings.integrations.bigblue.integrationCard.webhooksVerified")
                        : t("settings.integrations.bigblue.integrationCard.webhooksPending")
                    }
                  />
                  <ButtonLink
                    variant="ghost"
                    size="icon"
                    to="/settings/integrations/bigblue/connect"
                  >
                    <Pencil />
                  </ButtonLink>
                </div>
              ) : (
                <ButtonLink to="/settings/integrations/bigblue/connect">
                  {t("settings.integrations.bigblue.integrationCard.configButton")}
                </ButtonLink>
              )}
            </div>
          </CardHeader>
        </Card>
        <Section title={t("settings.integrations.bigblue.tools")}>
          <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-4">
            <FindOrder isDisabled={!hasConfiguration} disabledReason={disabledReason} />
          </div>
        </Section>
      </div>
      <Outlet />
    </>
  )
}
